module.exports = __webpack_public_path__ + "static/media/login (1).e6b6d7e2.svg";